import { parse } from 'date-fns';

// Parses a changelog string in markdown format and returns an array of { version, date, items: string[] }
export function parseChangelog(md: string) {
  const entries: {
    version: string;
    date: Date;
    items: string[];
    content: string;
    title?: string;
  }[] = [];
  const lines = md.split(/\r?\n/);
  let current: {
    version: string;
    date: Date;
    items: string[];
    content: string;
    title?: string;
  } | null = null;
  let buffer: string[] = [];
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const trimmed = line.trim();
    const match = trimmed.match(/^#### \[(.*?)\] - (\d{4}-\d{2}-\d{2})(?: - (.*))?/);
    if (match) {
      if (current) {
        current.content = buffer.slice(1).join('\n').trim();
        entries.push(current);
      }
      current = {
        version: match[1],
        date: parse(match[2], 'yyyy-MM-dd', new Date()),
        items: [],
        content: '',
        title: match[3]?.trim(),
      };
      buffer = [line];
    } else {
      if (current) {
        buffer.push(line);
        if (trimmed.startsWith('- ') || trimmed.startsWith('– ')) {
          current.items.push(trimmed.replace(/^[-–] /, ''));
        }
      }
    }
  }
  if (current) {
    current.content = buffer.slice(1).join('\n').trim();
    entries.push(current);
  }
  return entries;
}

export type ChangelogEntry = ReturnType<typeof parseChangelog>[0];
